// CommonHeader.tsx (Refactored - Apply-only filters, same UI)
import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Keyboard,
  ActivityIndicator,
  StatusBar,
  View,
  Text,
  StyleSheet,
  Dimensions,
  Pressable,
  Image,
  TextInput,
  FlatList,
  Platform,
  useWindowDimensions,
  TouchableOpacity,
  Animated,
  ScrollView,
  Alert,
  SafeAreaView,
  Modal,
} from "react-native";
import { useFocusEffect } from "@react-navigation/native";
import { Easing } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useTranslation } from "react-i18next";
import { useNavigation, useRoute } from "@react-navigation/native";
import LoadingDots from "react-native-loading-dots";
import i18next from "i18next";
import { DataContext } from "./DataContext";
import { API, COLORS, FONTS } from "../../utils";
import StarRating from "./starrating";
import RecentSearch from "./recentSearch";
import { OrientationContext } from "./OrientationContext";
import SuppplementnewsWeb from "./supplementnewsWeb";
import { MaterialIcons } from "@expo/vector-icons";
import { Toast } from "react-native-toast-notifications";
import Menu from "./BasicHeader/Menu";
import ProductRequest from "../screens/products/ProductRequest";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { getUserProfile } from "../apiCall/userApiCall";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import useAuth from "../hooks/useAuth";

type RootStackParamList = {
  Home: undefined;
  productRequest: undefined; // 👈 add this
};

// const Stack = createNativeStackNavigator<RootStackParamList>();

// export  function AppNavigator() {
//   return (
//     <Stack.Navigator>
      
//       <Stack.Screen name="productRequest" component={ProductRequest} />
//     </Stack.Navigator>
//   );
// }


const { width, height } = Dimensions.get("window");

const CommonHeader = ({
  title,
  showFilter,
  onDataFilter,
  marginTop,
  onRemoveFocus,
}) => {
  const isLandscape = useContext(OrientationContext);
  const { t } = useTranslation();
  const navigation = useNavigation();
  const route = useRoute();
  const { data2 } = useContext(DataContext);
  const currentLanguage = i18next?.language;

  // images (same as original)
  const DEMO = require("../assets/images/nutrilogo.png");
  const Search = require("../assets/images/magnify.png");
  const Cross = require("../assets/images/close.png");
  const Silver = require("../assets/images/silver.png");
  const Gold = require("../assets/images/gold.png");
  const dimond = require("../assets/images/dimond.png");
  const Platinum = require("../assets/images/platinum.png");
  const Filter = require("../assets/images/filter.png");
  const filterFill = require("../assets/images/filterfill.png");
  const filterUnfill = require("../assets/images/filterunfill.png");
  const fill = require("../assets/images/fillstar.png");
  const unfill = require("../assets/images/unfillstar.png");


  const {userDetails,setIUserDetails ,saveUserDetails,showSubscriptioModal,setShowSubscriptionModal}=useAuth()

  // Function to get subscription status
  const getSubscriptionStatus = () => {
    if (!userDetails) return 'expired';
    
    // Priority: Trial > Subscribe > Expired
    if (userDetails.is_trail === '1') {
      return 'trial';
    } else if (userDetails.is_subscribe === '1') {
      return 'active';
    } else {
      return 'expired';
    }
  };

  const getStatusColor = () => {
    const status = getSubscriptionStatus();
    switch (status) {
      case 'active': return '#4CAF50'; // Green
      case 'trial': return '#FFC107';  // Yellow
      case 'expired': return '#F44336'; // Red
      default: return '#F44336';
    }
  };

  // --- states for lists and results ---
  const [medalData, setMedalData] = useState([]);
  const [ratingData, setRatingData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [manufacturerData, setManufacturerData] = useState([]);

  const [filteredData, setFilteredData] = useState([]);
  const [filteredData2, setFilterData2] = useState([]);
  const [newsData, setNewsData] = useState([]);
  const [newsData2, setNewsData2] = useState([]);

  const [isActive, setIsActive] = useState(false);
  const [isShowLoading, setIsShowLoading] = useState(false);
  //language loader
  const [loading, setLoading] = useState(false);

  // --- search states (same behavior) ---
  const [searchListShow, setSearchListShow] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [recentSearch, setRecentSearch] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchVisible, setSearchVisible] = useState(false);

  // --- notification related (kept) ---
  const [notificationData, setNotificationData] = useState([]);
  const [formatedDate, setForamtedDate] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [animationValue] = useState(new Animated.Value(0));
  const [isToastVisible, setIsToastVisible] = useState(false);

  // --- modal visibility ---
  const [isModalVisible, setIsModalVisible] = useState(false);
console.log(userDetails)
  // --- FILTER states ---
  // applied = currently applied filters (used by header dot & actual API)
  const [appliedMedals, setAppliedMedals] = useState<number[]>([]);
  const [appliedCountries, setAppliedCountries] = useState<number[]>([]);
  const [appliedRatings, setAppliedRatings] = useState<number[]>([]);
  const [appliedManufactures, setAppliedManufactures] = useState<number[]>([]);
  const [appliedSort, setAppliedSort] = useState<"desc" | "asc">("desc");

  // temp = modal selections (user changes here; only on Apply do we copy to applied)
  const [tempMedals, setTempMedals] = useState<number[]>([]);
  const [tempCountries, setTempCountries] = useState<number[]>([]);
  const [tempRatings, setTempRatings] = useState<number[]>([]);
  const [tempManufactures, setTempManufactures] = useState<number[]>([]);
  const [tempSort, setTempSort] = useState<"desc" | "asc">("desc");

  // other UI flags
  const [newsShow, setNewsShow] = useState(false);

  // ------------------ effects ------------------
  useEffect(() => {
    saveUserDetails()
    // on mount, load filters & initial data (applied defaults)
    getData();
  }, []);

  useEffect(() => {
    // animate notification
    if (showNotification) {
      Animated.timing(animationValue, {
        toValue: 1,
        duration: 500,
        easing: Easing.ease,
        useNativeDriver: false,
      }).start();
    } else {
      Animated.timing(animationValue, {
        toValue: 0,
        duration: 500,
        easing: Easing.ease,
        useNativeDriver: false,
      }).start();
    }
  }, [showNotification]);

  useEffect(() => {
    // update local filteredData when data2 changes (same as before)
    const modifiedData = data2.results?.map((item) => ({
      ...item,
      concatName: `${item.company_name} ${item.product_name}`,
    }));
    setFilteredData(modifiedData);
    setFilterData2(modifiedData);
    setNewsData(data2.news);
    setNewsData2(data2.news);
    setNewsShow(title === t("Supplements in the news") ? true : false);
  }, [data2]);

  // ------------------ helper functions ------------------
  const notifyMessage = (msg) => {
    if (Platform.OS === "ios") {
      // optionally show Alert
    } else {
      if (!isToastVisible) {
        setIsToastVisible(true);
        setTimeout(() => setIsToastVisible(false), 1000);
      }
    }
  };

  //for reseting language
  const handleResetLanguage = async () => {
    try {
      await AsyncStorage.removeItem("Language"); // remove saved language
      navigation.reset({
        index: 0,
        routes: [{ name: "Splash" }], // go back to splash/login to reselect language
      });
    } catch (e) {
      console.log("Reset language error:", e);
    }
  };

  // fetch notifications (kept same)
  const fetchFaqData = async (value: any, id: any) => {
    try {
      const cachedData = await AsyncStorage.getItem(`notification_${id}`);
      let cachedResponse = cachedData ? JSON.parse(cachedData) : null;

      const response = await fetch(`${API.baseurl}notification`, {
        method: "GET",
        headers: {
          id: id,
          session_key: value,
          Authorization: "Basic YWRtaW46MTIzNA==",
        },
      });
      const result = await response.json();
      if (result?.status === 200) {
        const data = result?.data?.[0];
        setNotificationData(data || {});
        if (data?.created_at) {
          const createdAt = new Date(data.created_at);
          const year = createdAt.getFullYear();
          const month = createdAt.toLocaleString("default", { month: "long" });
          const day = createdAt.getDate();
          setForamtedDate(`${month} ${day}, ${year}`);
        }
        await AsyncStorage.setItem(`notification_${id}`, JSON.stringify(data));
        if (!cachedResponse || cachedResponse?.id !== data?.id) {
          setShowNotification(true);
          setTimeout(() => setShowNotification(false), 3000);
        }
      }
    } catch (err) {
      console.error("fetchFaqData error", err);
    }
  };

  // load filter lists from API
  const filterListing = async (value, id) => {
    setIsShowLoading(true);
    const headers = {
      id: id,
      session_key: value,
      Authorization: "Basic YWRtaW46MTIzNA==",
      Cookie: "ci_session=d5fbe110867808406780232c0fc22e5c35f24315",
    };
    try {
      const response = await fetch(`${API.baseurl}/filterlist`, {
        method: "GET",
        headers: new Headers(headers),
        redirect: "follow",
      });
      const result = await response.json();
      if (result?.status === 200) {
        const [medal, country, rating, manufacture] = result.data;
        setMedalData(medal.list || []);
        setCountryData(country.list || []);
        setRatingData(rating.list || []);
        setManufacturerData(manufacture.list || []);
      } else {
        notifyMessage(result?.message || "Failed to fetch filters");
      }
    } catch (err) {
      console.error("filterListing error", err);
      notifyMessage(err.message || "Error");
    } finally {
      setIsShowLoading(false);
    }
  };

  // call API to fetch filtered products (this uses applied filters)
  const filterProducts = async (
    medalsParam,
    ratingsParam,
    countriesParam,
    manufacturersParam,
    sort = "desc"
  ) => {
    setIsShowLoading(true);
    setIsActive(true);
    try {
      const [value, id] = await Promise.all([
        AsyncStorage.getItem("key"),
        AsyncStorage.getItem("id"),
      ]);

      const headers = new Headers({
        id: id,
        session_key: value,
        Authorization: "Basic YWRtaW46MTIzNA==",
        Cookie: "ci_session=bedc6f65ad68e3f0c6f369cbfee6f96efbf43f41",
      });

      // Normalize params to CSV strings (if arrays provided)
      const toCsv = (v) =>
        v === null || v === undefined
          ? ""
          : Array.isArray(v)
          ? v.length > 0
            ? v.join(",")
            : ""
          : v.toString();

      const q = `sort=${sort}&medals_id=${encodeURIComponent(
        toCsv(medalsParam)
      )}&countries_id=${encodeURIComponent(
        toCsv(countriesParam)
      )}&rating=${encodeURIComponent(
        toCsv(ratingsParam)
      )}&manufacturer=${encodeURIComponent(toCsv(manufacturersParam))}`;

      const apiUrl = `${API.baseurl}/filterdata?${q}`;

      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
        redirect: "follow",
      });
      const result = await response.json();

      if (result?.status === 200) {
        if (result?.data?.length > 0) {
          setFilteredData(result.data);
          sendProductsData(result.data);
        } else {
          setFilteredData([]);
          sendProductsData([]);
        }
      } else {
        notifyMessage(result?.message || "Failed to fetch products");
      }
    } catch (err) {
      console.error("filterProducts error", err);
      notifyMessage(err.message || "Error fetching products");
    } finally {
      setIsShowLoading(false);
      setIsActive(false);
    }
  };

  // wrapper to call parent with products
  const sendProductsData = (data) => {
    if (onDataFilter) {
      onDataFilter(data && data.length > 0 ? data : null);
    }
  };

  // initial data load
  const getData = async () => {
    try {
      const [value, id] = await Promise.all([
        AsyncStorage.getItem("key"),
        AsyncStorage.getItem("id"),
      ]);
      if (value && id) {
        await filterListing(value, id);
        // load initial products with applied (empty) filters
        filterProducts([], [], [], [], appliedSort);
        fetchFaqData(value, id);
      }
    } catch (err) {
      console.error("getData error", err);
    }
  };

  // ----------------- modal open/close and control -----------------
  const openModal = () => {
    // populate temp selections with applied ones (so user sees current applied)
    setTempMedals([...appliedMedals]);
    setTempCountries([...appliedCountries]);
    setTempRatings([...appliedRatings]);
    setTempManufactures([...appliedManufactures]);
    setTempSort(appliedSort);
    setIsModalVisible(true);
  };
  const closeModal = () => setIsModalVisible(false);

  // Reset: clears applied + temp and fetches default data (applied reset)
  const resetFilter = () => {
    setAppliedMedals([]);
    setAppliedCountries([]);
    setAppliedRatings([]);
    setAppliedManufactures([]);
    setAppliedSort("desc");

    setTempMedals([]);
    setTempCountries([]);
    setTempRatings([]);
    setTempManufactures([]);
    setTempSort("desc");

    // immediately apply empty filters (user expects reset to clear results)
    filterProducts([], [], [], [], "desc");
  };

  // Apply: set applied = temp, call filterProducts, close modal
  const applyFilters = () => {
    setAppliedMedals([...tempMedals]);
    setAppliedCountries([...tempCountries]);
    setAppliedRatings([...tempRatings]);
    setAppliedManufactures([...tempManufactures]);
    setAppliedSort(tempSort);

    // call api with applied filters
    filterProducts(
      tempMedals,
      tempRatings,
      tempCountries,
      tempManufactures,
      tempSort
    );
    setIsModalVisible(false);
  };

  // ----------------- temp selection toggles (modal only) -----------------
  const toggleTempMedal = (id) => {
    setTempMedals((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
  const toggleTempCountry = (id) => {
    setTempCountries((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
  const toggleTempRating = (id) => {
    setTempRatings((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
  const toggleTempManufacture = (id) => {
    setTempManufactures((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  // ----------------- old handlers (kept for search & recent items) -----------------
  const handleFocus = () => {
    setSearchListShow(true);
  };

  const handleSearch = (text) => {
    setSearchQuery(text);
    if (!text || text.length <= 0) {
      setFilteredData(filteredData2);
      setNewsData(newsData2);
      setSearchListShow(false);
      return;
    }
    setSearchListShow(true);
    const words = text.trim().toLowerCase().split(/\s+/);
    const sanitizeString = (str) =>
      String(str || "")
        .replace(/[^a-zA-Z0-9 ]/g, "")
        .toLowerCase();

    const filtered = filteredData2?.filter((item: any) =>
      words.every(
        (word) =>
          sanitizeString(item?.star_rating ?? "").includes(
            sanitizeString(word)
          ) ||
          sanitizeString(item?.countries_name ?? "").includes(
            sanitizeString(word)
          ) ||
          sanitizeString(item?.medal ?? "").includes(sanitizeString(word)) ||
          sanitizeString(item?.concatName ?? "").includes(sanitizeString(word))
      )
    );
    const filteredNews = newsData2
      ?.filter(
        (itm) =>
          words.some((w) =>
            sanitizeString(itm?.title ?? "").includes(sanitizeString(w))
          ) ||
          words.some((w) =>
            sanitizeString(itm?.tags ?? "").includes(sanitizeString(w))
          )
      )
      .sort((a, b) => {
        const aTitleMatches = words.some((word) =>
          sanitizeString(a?.title ?? "").includes(sanitizeString(word))
        );
        const bTitleMatches = words.some((word) =>
          sanitizeString(b?.title ?? "").includes(sanitizeString(word))
        );
        if (aTitleMatches && !bTitleMatches) return -1;
        if (!aTitleMatches && bTitleMatches) return 1;
        return 0;
      });
    setFilteredData(filtered);
    setNewsData(filteredNews);
  };

  // recent selected items storage
  const loadSelectedItems = async () => {
    try {
      const storedItems = await AsyncStorage.getItem("selectedItems");
      if (storedItems) {
        setSelectedItems(JSON.parse(storedItems));
        setRecentSearch(JSON.parse(storedItems));
      }
    } catch (err) {
      console.error("loadSelectedItems", err);
    }
  };
  const saveSelectedItems = async (items) => {
    try {
      await AsyncStorage.setItem("selectedItems", JSON.stringify(items));
      setRecentSearch(items);
    } catch (err) {
      console.error("saveSelectedItems", err);
    }
  };
  const handleItemClick = (item) => {
    const isItemSelected = selectedItems.some((s) => s.id === item.id);
    const updated = isItemSelected ? selectedItems : [...selectedItems, item];
    setSelectedItems(updated);
    saveSelectedItems(updated);
  };
  // for reseting search screen

  useFocusEffect(
    React.useCallback(() => {
      return () => {
        setSearchQuery(""); // reset input
        setSearchVisible(false);
        setSearchListShow(false); // hide search
      };
    }, [])
  );

  // render product item (kept same)
  const renderItem3 = ({ item }) => {
    const updatedDate = item.updated_at?.split?.(" ")[0] || "";
    const showCountry = item?.countries_name ? `(${item.countries_name})` : "";
    const medalsMap = { 1: Platinum, 2: dimond, 3: Gold, 4: Silver };
    return (
      <TouchableOpacity
        activeOpacity={0.6}
        onPress={() => {
          handleItemClick(item);
          setSearchListShow(false);
          setSearchQuery("");
          if (item?.countries_iso_code?.length > 0) {
            navigation.navigate("Graph", {
              item: item,
              previousRoute: route.name,
            });
          }
        }}
        style={styles.itemContainer}
      >
        <View style={styles.itemView}>
          <View
            style={[
              styles.itemContentView,
              item?.medal_status == 0 ? { width: "100%" } : { width: "90%" },
            ]}
          >
            <View style={styles.itemNameView}>
              <Text
                style={styles.combinedText}
                numberOfLines={1}
                ellipsizeMode="tail"
              >
                {item?.company_name} {item?.product_name}
              </Text>
            </View>
            <View style={styles.countryNameView}>
              <Text style={styles.countryName}>{showCountry}</Text>
            </View>
            <View style={styles.ratingView}>
              <StarRating
                rating={item?.star_rating}
                customStarImage={{ filled: fill, empty: unfill }}
                height={10}
                width={11}
              />
              <Text style={styles.rating} allowFontScaling={false}>
                {item?.star_rating}
              </Text>
            </View>
          </View>
          <View style={styles.medalView}>
            <Image
              source={medalsMap[item?.medal_status]}
              style={styles.medalImage}
            />
          </View>
        </View>
        {updatedDate !== "0000-00-00" && (
          <Text style={styles.date} allowFontScaling={false}>
            {t("last updated")} : {updatedDate}
          </Text>
        )}
      </TouchableOpacity>
    );
  };

  // ----------------- UI render -----------------
  return (
    <Pressable
      onPress={() => setSearchListShow(false)}
      style={styles.container}
    >
      <StatusBar
        animated
        barStyle={"light-content"}
        backgroundColor={"transparent"}
        translucent
      />
      <View
        style={{
          position: "absolute",
          top: 70,
          right: 10,
          zIndex: 5,
        }}
      >
        {/* <Menu/> */}
      </View>

      <Pressable
        onPress={() => setSearchListShow(false)}
        style={[
          styles.View1,
          {
            flexDirection: isLandscape ? "row" : "column",
            paddingTop: isLandscape ? 17 : height / 15,
          },
        ]}
      >
        <View style={[styles.headerView, {}]}>
          <Text
            allowFontScaling={false}
            style={[
              styles.title,
              {
                marginTop:
                  Platform.OS === "ios"
                    ? currentLanguage === "ko"
                      ? 4
                      : 0
                    : 0,
              },
            ]}
          >
            {title}
          </Text>
          
          {/* Subscription Status Indicator */}
          <TouchableOpacity 
            style={styles.subscriptionIndicator}
            onPress={() => navigation.navigate('MySubscripion')}
            activeOpacity={0.7}
          >
            <View 
              style={[
                styles.statusDot, 
                { backgroundColor: getStatusColor() }
              ]} 
            />
          </TouchableOpacity>
        </View>

        {/* Full-screen loader overlay */}
        {loading && (
          <View
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.4)", // semi-transparent background
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ActivityIndicator size="large" color="#fff" />
          </View>
        )}

        {/* Search Box */}
        <Pressable
          onPress={() => setSearchListShow(!searchListShow)}
          style={[
            styles.searchContainer,
            Platform.OS === "web" ? styles.webWidth : { width: width - 32 },
          ]}
        >
          <View
            style={[
              styles.searchBarView,
              {
                borderBottomLeftRadius: searchListShow ? 0 : 6,
                borderBottomRightRadius: searchListShow ? 0 : 6,
                borderColor: searchListShow ? "#214F71" : COLORS.white,
              },
            ]}
          >
            <Image source={Search} style={styles.searchIcon} />
            <View
              style={{
                alignItems: "center",
                height: 44,
                flex: 1,
                flexDirection: "row",
              }}
            >
              <TextInput
                style={[
                  styles.searchInput2,
                  Platform.OS === "web" && styles.webSearchInput,
                  {
                    flex: 1,
                    fontFamily: FONTS.PoppinsMedium,
                    color: COLORS.primarygraycolor,
                    paddingVertical: 0,
                  },
                ]}
                placeholder={t("Search")}
                placeholderTextColor={COLORS.primarygraycolor}
                onFocus={handleFocus}
                onChangeText={handleSearch}
                value={searchQuery}
                selectionColor={COLORS.primary}
              />
              {searchQuery.length > 0 && (
                <TouchableOpacity
                  onPress={() => setSearchQuery("")}
                  style={{ paddingHorizontal: 8 }}
                >
                  <Image
                    source={Cross}
                    style={{
                      width: 20,
                      height: 20,
                      tintColor: COLORS.primarygraycolor,
                    }}
                    resizeMode="contain"
                  />
                </TouchableOpacity>
              )}
            </View>

            {/* Filter button: show dot if applied filters exist */}
            {showFilter && (
              <Pressable
                onPress={() => {
                  Keyboard.dismiss();
                  openModal();
                  setSearchListShow(false);
                  setSearchQuery("");
                }}
                style={styles.filterButton}
              >
                {(appliedMedals.length > 0 ||
                  appliedCountries.length > 0 ||
                  appliedRatings.length > 0 ||
                  appliedManufactures.length > 0) && (
                  <Text allowFontScaling={false} style={styles.filterDot}>
                    .
                  </Text>
                )}
                <Text allowFontScaling={false} style={styles.filterText}>
                  {t("Filter")}
                </Text>
                <Image style={styles.filterIcon} source={Filter} />
              </Pressable>
            )}
          </View>

          {/* Search list dropdown */}
          {searchListShow && (
            <View
              style={[
                styles.nestedContainer1,
                Platform.OS === "web"
                  ? {
                      position: "absolute",
                      top: 48,
                      flex: 1,
                      minHeight:
                        !searchQuery && recentSearch.length > 0 ? 200 : 307,
                    }
                  : {
                      minHeight:
                        !searchQuery && recentSearch.length > 0 ? 200 : 307,
                    },
              ]}
            >
              {!searchQuery && recentSearch.length > 0 ? (
                <RecentSearch data={recentSearch} />
              ) : (
                <>
                  <View style={styles.tabSwitch}>
                    <TouchableOpacity onPress={() => setNewsShow(false)}>
                      <Text
                        style={[styles.tabText, !newsShow && styles.activeTab]}
                      >
                        Products
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => setNewsShow(true)}>
                      <Text
                        style={[
                          styles.tabText,
                          styles.tabTextMargin,
                          newsShow && styles.activeTab,
                        ]}
                      >
                        News
                      </Text>
                    </TouchableOpacity>
                  </View>

                  {isActive ? (
                    <ActivityIndicator
                      size="small"
                      color={COLORS.primary}
                      style={styles.loadingIndicator}
                    />
                  ) : (
                    <>
                      {newsShow === false ? (
                        filteredData?.length > 0 ? (
                          <FlatList
                            style={styles.flatListView}
                            showsVerticalScrollIndicator={false}
                            data={filteredData}
                            renderItem={renderItem3}
                            keyboardShouldPersistTaps="handled"
                            keyExtractor={(item) => item.id.toString()}
                          />
                        ) : (
                          <Text
                            allowFontScaling={false}
                            style={styles.noResultText}
                          >
                            Sorry, we couldn't find any product results
                          </Text>
                        )
                      ) : newsData?.length > 0 ? (
                        <FlatList
                          keyboardShouldPersistTaps="handled"
                          style={styles.flatListStyle}
                          showsVerticalScrollIndicator={false}
                          data={newsData}
                          renderItem={({ item }) => (
                            <SuppplementnewsWeb item={item} marginBottom={10} />
                          )}
                          keyExtractor={(item) => item.id.toString()}
                        />
                      ) : (
                        <Text
                          allowFontScaling={false}
                          style={styles.noResultText}
                        >
                          Sorry, we couldn't find any news results
                        </Text>
                      )}
                    </>
                  )}
                </>
              )}
            </View>
          )}
        </Pressable>

        {/* small loading indicator near filter */}
        {isShowLoading === true && showFilter && (
          <ActivityIndicator
            position={"absolute"}
            size={"small"}
            style={{ top: Platform.OS === "web" ? 30 : 30 }}
            color={COLORS.primary}
          />
        )}
        <View style={styles.buttons}>
          {/* Reset button */}
          {i18next.language !== "en" && (
            <TouchableOpacity
              onPress={async () => {
                setLoading(true);
                setTimeout(async () => {
                  try {
                    await i18next.changeLanguage("en");
                    await AsyncStorage.setItem("Language", "en");
                    navigation.reset({
                      index: 0,
                      routes: [{ name: "Splash" }],
                    });
                  } catch (error) {
                    console.error("Failed to reset language:", error);
                  } finally {
                    setLoading(false);
                  }
                }, 100);
              }}
              style={{
                backgroundColor: "white",
                paddingVertical: 10,
                paddingHorizontal: 12,
                borderRadius: 8,
                alignSelf: "flex-end",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                minWidth: 130,
                minHeight: 44,
                borderWidth: 1,
                borderColor: COLORS.primary,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.1,
                shadowRadius: 3,
                elevation: 2,
                marginRight: 15,
                marginBottom: 10,
              }}
              disabled={loading}
            >
              <Image
                source={require("../../assets/globe.png")} // replace with your PNG path
                style={{ width: 20, height: 20, marginRight: 8 }}
                resizeMode="contain"
                tintColor={COLORS.primary}
              />
              <Text
                style={{
                  color: COLORS.primary,
                  fontSize: 16,
                  fontWeight: "bold",
                  fontFamily: "Poppins-Medium",
                }}
              >
                Reset Language
              </Text>
            </TouchableOpacity>
          )}
          {/* Reset button */}
         
            <TouchableOpacity
              onPress={() => {
                console.log('retyuhkl',userDetails.is_trail , userDetails.is_subscribe)
                console.log(userDetails)
                if(userDetails.is_trail=="1" || userDetails.is_subscribe=="1"){
                   navigation.navigate("productRequest");
// setShowSubscriptionModal(true)
                }else{
                  setShowSubscriptionModal(true)
                }
              }}
              style={{
                backgroundColor: "white",
                paddingVertical: 10,
                paddingHorizontal: 12,
                borderRadius: 8,
                alignSelf: "flex-end",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                minWidth: 130,
                minHeight: 44,
                borderWidth: 1,
                borderColor: COLORS.primary,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.1,
                shadowRadius: 3,
                elevation: 2,
                marginRight: 15,
                marginBottom: 10,
              }}
              disabled={loading}
            >
              <Image
                source={require("../assets/images/productfill.png")} // replace with your PNG path
                style={{ width: 20, height: 20, marginRight: 8 }}
                resizeMode="contain"
                tintColor={COLORS.primary}
              />
              <Text
                style={{
                  color: COLORS.primary,
                  fontSize: 16,
                  fontWeight: "bold",
                  fontFamily: "Poppins-Medium",
                }}
              >
                Product Request
              </Text>
            </TouchableOpacity>
         
        </View>
      </Pressable>

      {/* ------------------ FILTER MODAL ------------------ */}
      <Modal
        animationType="slide"
        transparent
        visible={isModalVisible}
        onRequestClose={closeModal}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <View
              style={[
                styles.filterContainer,
                { height: isLandscape ? width - 50 : height - 80 },
              ]}
            >
              {/* header row with cross/reset/title/apply */}
              <View style={styles.nestedView}>
                <Pressable onPress={closeModal} style={styles.crossButton}>
                  <Image
                    source={require("../assets/images/cross.png")}
                    style={styles.crossImage}
                  />
                </Pressable>

                <TouchableOpacity
                  activeOpacity={0.7}
                  onPress={resetFilter}
                  style={styles.resetButton}
                >
                  <Text style={styles.resetText}>{t("Reset")}</Text>
                </TouchableOpacity>

                <Text allowFontScaling={false} style={styles.filterTitle}>
                  {t("Filter")}
                </Text>

                <View
                  style={[
                    styles.applyButtonContainer,
                    {
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "row",
                      width: 310,
                    },
                  ]}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      backgroundColor: "#f8f9fa",
                      borderRadius: 24,
                      padding: 4,
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 1 },
                      shadowOpacity: 0.1,
                      shadowRadius: 2,
                      elevation: 2,
                    }}
                  >
                    <TouchableOpacity
                      onPress={() => setTempSort("desc")}
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        backgroundColor:
                          tempSort === "desc" ? "#4a6da7" : "transparent",
                        paddingHorizontal: 12,
                        paddingVertical: 6,
                        borderRadius: 20,
                      }}
                    >
                      <MaterialIcons
                        name="new-releases"
                        size={16}
                        color={tempSort === "desc" ? "white" : "#7f8c8d"}
                      />
                      {tempSort === "desc" && (
                        <Text
                          style={{
                            color: "white",
                            fontSize: 12,
                            fontWeight: "600",
                            marginLeft: 4,
                          }}
                        >
                          Latest
                        </Text>
                      )}
                    </TouchableOpacity>

                    <TouchableOpacity
                      onPress={() => setTempSort("asc")}
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        backgroundColor:
                          tempSort === "asc" ? "#4a6da7" : "transparent",
                        paddingHorizontal: 12,
                        paddingVertical: 6,
                        borderRadius: 20,
                      }}
                    >
                      <MaterialIcons
                        name="history"
                        size={16}
                        color={tempSort === "asc" ? "white" : "#7f8c8d"}
                      />
                      {tempSort === "asc" && (
                        <Text
                          style={{
                            color: "white",
                            fontSize: 12,
                            fontWeight: "600",
                            marginLeft: 4,
                          }}
                        >
                          Oldest
                        </Text>
                      )}
                    </TouchableOpacity>
                  </View>

                  <TouchableOpacity
                    activeOpacity={0.7}
                    onPress={applyFilters}
                    style={styles.applyButton}
                  >
                    <Text style={styles.applyText}>{t("Apply")}</Text>
                  </TouchableOpacity>
                </View>
              </View>

              {/* Selected filters bar (shows temp selections inside modal) */}
              {[
                ...medalData.filter((m) => tempMedals.includes(m.id)),
                ...countryData.filter((c) => tempCountries.includes(c.id)),
                ...ratingData.filter((r) => tempRatings.includes(r.id)),
                ...manufacturerData.filter((m) =>
                  tempManufactures.includes(m.id)
                ),
              ].length > 0 && (
                <View style={{ marginBottom: 10, paddingHorizontal: 10 }}>
                  <Text style={styles.sectionTitle}>
                    {t("Selected Filters")}
                  </Text>
                  <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                    {[
                      ...medalData.filter((m) => tempMedals.includes(m.id)),
                      ...countryData.filter((c) =>
                        tempCountries.includes(c.id)
                      ),
                      ...ratingData.filter((r) => tempRatings.includes(r.id)),
                      ...manufacturerData.filter((m) =>
                        tempManufactures.includes(m.id)
                      ),
                    ].map((item) => (
                      <Pressable
                        key={item.id}
                        onPress={() => {
                          if (tempMedals.includes(item.id))
                            toggleTempMedal(item.id);
                          else if (tempCountries.includes(item.id))
                            toggleTempCountry(item.id);
                          else if (tempRatings.includes(item.id))
                            toggleTempRating(item.id);
                          else if (tempManufactures.includes(item.id))
                            toggleTempManufacture(item.id);
                        }}
                        style={[
                          styles.pressableContainer3,
                          {
                            backgroundColor: COLORS.primary,
                            flexDirection: "row",
                            alignItems: "center",
                            margin: 4,
                          },
                        ]}
                      >
                        <Text
                          allowFontScaling={false}
                          style={[styles.text3, { color: "white" }]}
                        >
                          {item.filter}
                        </Text>
                        <Image
                          source={require("../assets/images/cross.png")}
                          style={{ width: 14, height: 14, marginLeft: 6 }}
                        />
                      </Pressable>
                    ))}
                  </View>
                </View>
              )}

              {/* Scrollable filters (user toggles here - temp only) */}
              <ScrollView style={{ flex: 1 }}>
                {[
                  {
                    title: t("Medals"),
                    data: medalData,
                    toggle: toggleTempMedal,
                    selected: tempMedals,
                  },
                  {
                    title: t("Countries"),
                    data: countryData,
                    toggle: toggleTempCountry,
                    selected: tempCountries,
                  },
                  {
                    title: t("Rating"),
                    data: ratingData,
                    toggle: toggleTempRating,
                    selected: tempRatings,
                  },
                  {
                    title: t("Manufacturer"),
                    data: manufacturerData,
                    toggle: toggleTempManufacture,
                    selected: tempManufactures,
                  },
                ].map(({ title, data, toggle, selected }) => (
                  <View
                    key={title}
                    style={[
                      styles.section,
                      title === t("Manufacturer") && { paddingBottom: 100 },
                    ]}
                  >
                    <Text style={styles.sectionTitle}>{title}</Text>
                    <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                      {data.map((item) => {
                        const isSelected = selected.includes(item.id);
                        return (
                          <Pressable
                            key={item.id}
                            onPress={() => toggle(item.id)}
                            style={[
                              styles.pressableContainer3,
                              {
                                width: "auto",
                                backgroundColor: isSelected
                                  ? COLORS.primary
                                  : "white",
                              },
                            ]}
                          >
                            <Image
                              style={styles.image3}
                              source={isSelected ? filterFill : filterUnfill}
                            />
                            <Text
                              allowFontScaling={false}
                              style={[
                                styles.text3,
                                {
                                  color: isSelected
                                    ? "white"
                                    : COLORS.darkbordercolor,
                                },
                              ]}
                            >
                              {item.filter}
                            </Text>
                          </Pressable>
                        );
                      })}
                    </View>
                  </View>
                ))}
              </ScrollView>
            </View>
          </View>
        </View>
      </Modal>

      {/* Notification animated card (kept same) */}
      <Animated.View
        style={[
          styles.notification,
          {
            transform: [
              {
                translateY: animationValue.interpolate({
                  inputRange: [0, 1],
                  outputRange: [-50, 0],
                }),
              },
            ],
            opacity: animationValue,
          },
        ]}
      >
        <View
          style={{
            paddingLeft: 20,
            paddingRight: 5,
            paddingBottom: 6,
            marginTop: 5,
          }}
        >
          <View style={styles.cardContainer}>
            <View style={styles.imageContainer}>
              <Image source={DEMO} style={styles.image} />
            </View>
            <View style={styles.textContainer}>
              <Text
                style={[styles.nTitle, { borderWidth: 0, width: width - 210 }]}
              >
                {notificationData?.title}
              </Text>
              <Text style={styles.nDes}>{notificationData?.message}</Text>
            </View>
            <Text style={styles.time}>{formatedDate}</Text>
          </View>
        </View>
      </Animated.View>
    </Pressable>
  );
};

export default CommonHeader;

/* --------------------- styles (kept mostly same as original) --------------------- */
const styles = StyleSheet.create({
  container: { zIndex: 10000 },
  searchContainer: {
    alignSelf: "center",
    borderRadius: 6,
    maxWidth: 436,
    minWidth: 325,
  },
  buttons: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 20,
  },
  topRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10, // spacing between top row & search
  },
  resetButton: {
    backgroundColor: "#eee",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
  },
  resetButtonText: {
    fontSize: 14,
    fontWeight: "600",
    color: "#333",
  },

  webWidth: { width: "50%" },
  searchBarView: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 15,
    borderTopRightRadius: 6,
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    borderWidth: 1.5,
    backgroundColor: "#fff",
  },
  searchIcon: { width: 20, height: 20 },
  searchInput: {
    marginLeft: 10,
    paddingRight: 10,
    height: 44,
    width: "65%",
    lineHeight: 44,
    textAlignVertical: "center",
    paddingVertical: 0,
  },
  searchInput2: {
    marginLeft: 10,
    paddingRight: 10,
    height: "100%",
    width: "100%",
  },
  webSearchInput: {
    width: "100%",
    outlineColor: "white",
    outlineStyle: "none",
  },
  View1: {
    width: "100%",
    backgroundColor: COLORS.primary,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    paddingBottom: 20,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  headerView: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingRight: 15,
  },
  title: {
    alignSelf: "center",
    textAlign: "center",
    fontSize: 22,
    maxWidth: 300,
    color: COLORS.white,
    fontFamily: "Poppins-SemiBold",
    fontWeight: Platform.OS === "web" ? "400" : "600",
    paddingVertical: 6,
  },
  SearchBarView: {
    backgroundColor: "white",
    width: Platform.OS === "web" ? "100%" : width - 32,
    alignSelf: "center",
    marginTop: 0,
    flexDirection: "row",
    alignItems: "center",
    paddingRight: 10,
    paddingLeft: 30,
  },
  filterButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "28%",
    height: "90%",
    borderLeftWidth: 1,
    borderColor: "#6F747966",
  },
  filterDot: {
    fontSize: 100,
    position: "absolute",
    right: -4,
    bottom: 2,
    color: COLORS.primary,
  },
  filterText: {
    fontWeight: "600",
    fontFamily:
      Platform.OS === "web"
        ? "'Poppins SemiBold', sans-serif"
        : FONTS.PoppinsSemiBold,
    fontSize: 14,
    lineHeight: 21,
    color: "#6F7479",
  },
  filterIcon: { height: 18, width: 18 },
  nestedContainer1: {
    backgroundColor: "white",
    maxWidth: Platform.OS === "web" ? 436 : "99.5%",
    minWidth: 325,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    alignSelf: "center",
    maxHeight: 340,
    paddingLeft: 10,
    paddingTop: 15,
    shadowColor: "black",
    shadowOffset: { width: 0, height: 14 },
    shadowOpacity: 0.3,
    shadowRadius: 6,
    elevation: 5,
    paddingRight: 10,
    width: "100%",
  },
  nestedView: {
    height: 50,
    backgroundColor: "white",
    flexDirection: "row",
    alignItems: "center",
    paddingRight: 15,
    paddingLeft: 15,
    borderTopRightRadius: 12,
    justifyContent: "center",
    borderTopLeftRadius: 12,
    marginTop: 0,
  },
  pressableContainer3: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 7,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: COLORS.darkbordercolor,
    marginBottom: 10,
    marginRight: 10,
    height: 37,
    alignItems: "center",
    maxWidth: width - 40,
  },
  image3: { height: 14, width: 14, resizeMode: "contain", marginRight: 4 },
  text3: {
    fontFamily: FONTS.PoppinsMedium,
    fontWeight: "400",
    fontSize: 14,
    lineHeight: 21,
  },
  filterContainer: { borderWidth: 0 },
  crossButton: {
    position: "absolute",
    right: Platform.OS == "ios" ? 2 : -2,
    bottom: 30,
    borderWidth: 0,
  },
  crossImage: { height: 36, width: 36 },
  resetButton: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 12,
    borderRadius: 6,
    height: 38,
    alignItems: "center",
    position: "absolute",
    left: Platform.OS === "web" ? 20 : 14,
    top: 10,
    backgroundColor: "#fff",
  },
  resetText: {
    fontFamily: FONTS.PoppinsMedium,
    fontWeight: "400",
    fontSize: 18,
    lineHeight: 21,
    color: COLORS.primary,
  },
  filterTitle: {
    fontFamily: FONTS.PoppinsSemiBold,
    color: COLORS.primary,
    fontSize: 24,
    textAlign: "center",
    lineHeight: 36,
    fontWeight: "600",
    alignSelf: "center",
    marginTop: 8,
  },
  applyButtonContainer: {
    flexDirection: "row",
    position: "absolute",
    right: Platform.OS === "web" ? 20 : 20,
    top: 8,
  },
  applyButton: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderRadius: 6,
    height: 38,
    alignItems: "center",
    position: "absolute",
    right: Platform.OS === "web" ? 10 : 10,
    top: 0,
    backgroundColor: "#fff",
  },
  applyText: {
    fontFamily: FONTS.PoppinsMedium,
    fontWeight: "400",
    fontSize: 18,
    lineHeight: 21,
    color: COLORS.primary,
  },
  section: {
    paddingRight: 10,
    paddingLeft: 18,
    marginTop: height > 800 ? 15 : 2,
    borderWidth: 0,
  },
  sectionTitle: {
    fontWeight: "500",
    fontSize: 17,
    lineHeight: 24,
    color: COLORS.primary,
    fontFamily: FONTS.PoppinsSemiBold,
    marginBottom: 10,
  },
  itemContainer: {
    borderWidth: 1,
    borderRadius: 16,
    borderColor: COLORS.primarybordercolor,
    backgroundColor: "white",
    paddingBottom: 10,
    padding: 2,
    width: "auto",
    marginBottom: 7,
  },
  itemView: { flexDirection: "row" },
  itemContentView: { maxWidth: "100%", paddingTop: 8, paddingLeft: 7 },
  itemNameView: { flexDirection: "column", alignItems: "flex-start" },
  combinedText: {
    fontFamily: FONTS.PoppinsMedium,
    fontWeight: "700",
    fontSize: 14,
    color: COLORS.primary,
    flexShrink: 1,
  },
  countryNameView: { flexDirection: "row", alignItems: "center" },
  countryName: {
    fontFamily: FONTS.PoppinsMedium,
    fontSize: 12,
    color: COLORS.primarygraycolor,
    marginVertical: 4,
  },
  ratingView: { flexDirection: "row", alignItems: "center", height: 13 },
  rating: {
    marginLeft: 10,
    color: COLORS.black,
    fontFamily: FONTS.PoppinsMedium,
    fontWeight: "600",
    fontSize: 12,
  },
  medalView: { position: "absolute", right: 8, width: 30, top: -10 },
  medalImage: { height: 35, width: 35 },
  date: {
    bottom: 6,
    fontFamily: FONTS.PoppinsRegular,
    fontSize: 12,
    fontWeight: "400",
    color: COLORS.primarygraycolor,
    lineHeight: 18,
    alignSelf: "flex-end",
    position: "absolute",
    right: 10,
  },
  flatListView: { height: 250 },
  noResultText: {
    marginTop: 35,
    color: COLORS.primarygraycolor,
    fontFamily: FONTS.PoppinsSemiBold,
    textAlign: "center",
  },
  modalContainer: {
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.4)",
  },
  modalContent: {
    width: "100%",
    paddingBottom: 10,
    backgroundColor: "#fff",
    borderRadius: 20,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  notification: {
    position: "absolute",
    top: 20,
    left: 0,
    right: 10,
    alignSelf: "center",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  cardContainer: {
    borderWidth: 0,
    height: "auto",
    flexDirection: "row",
    backgroundColor: "white",
    borderRadius: 10,
    shadowColor: COLORS.primary,
    shadowOffset: { width: 0, height: 14 },
    shadowOpacity: 0.3,
    shadowRadius: 6,
    elevation: Platform.OS === "web" ? 0.1 : 5,
    maxWidth: 500,
    minWidth: 325,
    padding: Platform.OS == "web" ? 15 : 6,
  },
  imageContainer: { width: "17%", borderWidth: 0 },
  image: { height: 50, width: 50 },
  textContainer: { width: "83%", borderWidth: 0 },
  nTitle: { color: "black", fontSize: 16, fontFamily: "Poppins-Medium" },
  nDes: {
    color: "gray",
    fontSize: 13,
    fontWeight: "400",
    fontFamily: FONTS.PoppinsRegular,
    marginTop: 5,
  },
  time: {
    position: "absolute",
    right: 10,
    top: 5,
    color: COLORS.primary,
    fontWeight: "700",
  },
  subscriptionIndicator: {
    position: "absolute",
    right: 15,
    top: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    padding: 8,
  },
  statusDot: {
    width: 16,
    height: 16,
    borderRadius: 8,
    borderWidth: 3,
    borderColor: 'white',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.5,
    shadowRadius: 4,
    elevation: 5,
  },
});
